<template>
  <div class="footer-container">
    <div class="footer-information-container">
      <div class="contact-information-container">
        <div class="header-text">หากมีเหตุขัดข้องในการใช้ระบบ กรุณาติดต่อ</div>
        <div class="information-text">โทร(วันทำการ): 02-695-0800 ต่อ 2951 หรือ 2949</div>
        <div class="information-text">E-mail: support_tmbhcp@thaivivat.co.th</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss">
.footer-container {
  background-color: #ebeff2;
  box-shadow: 0 4px 20px 0 rgba(52, 73, 94, 0.2);
  margin-top: 4px;
  padding: 24px 32px;

  .header-text {
    font-family: 'psl_kanda_extraregular' !important;

    @extend .information-text;
  }

  .information-text {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 4px;
  }
}
</style>
